<section class="hiring-partners-section" data-testid="logo-marquee">
  <p class="hiring-partners-title">Our Hiring Partners</p>
  <div class="marquee-container">
    <div class="marquee-content">

      <div class="marquee-item">
        <img alt="1Vendor" class="marquee-logo" loading="lazy" src="assets/images/companies-logo/1Vendor.png">
        <span class="marquee-text">1Vendor</span>
      </div>
      <div class="marquee-item">
        <img alt="Acennavadhan" class="marquee-logo" loading="lazy" src="assets/images/companies-logo/Acennavadhan.png">
        <span class="marquee-text">Acennavadhan</span>
      </div>
      <div class="marquee-item">
        <img alt="Alpever" class="marquee-logo" loading="lazy" src="assets/images/companies-logo/Alpever.png">
        <span class="marquee-text">Alpever</span>
      </div>
      <div class="marquee-item">
        <img alt="Funstay" class="marquee-logo" loading="lazy" src="assets/images/companies-logo/Funstay.png">
        <span class="marquee-text">Funstay</span>
      </div>
      <div class="marquee-item">
        <img alt="OptInn Solutions" class="marquee-logo" loading="lazy" src="assets/images/companies-logo/OptInn-solutions.png">
        <span class="marquee-text">OptInn Solutions</span>
      </div>
      <div class="marquee-item">
        <img alt="TACT" class="marquee-logo" loading="lazy" src="assets/images/companies-logo/TACT.png">
        <span class="marquee-text">TACT</span>
      </div>
      <div class="marquee-item">
        <img alt="Yolohealth" class="marquee-logo" loading="lazy" src="assets/images/companies-logo/Yolohealth.png">
        <span class="marquee-text">Yolohealth</span>
      </div>
      <div class="marquee-item">
        <img alt="Thrillophilia" class="marquee-logo" loading="lazy" src="assets/images/companies-logo/thrillophilia.png">
        <span class="marquee-text">Thrillophilia</span>
      </div>
      <!-- Duplicated set for seamless marquee scrolling -->
      <div class="marquee-item">
        <img alt="1Vendor" class="marquee-logo" loading="lazy" src="assets/images/companies-logo/1Vendor.png">
        <span class="marquee-text">1Vendor</span>
      </div>
      <div class="marquee-item">
        <img alt="Acennavadhan" class="marquee-logo" loading="lazy" src="assets/images/companies-logo/Acennavadhan.png">
        <span class="marquee-text">Acennavadhan</span>
      </div>
      <div class="marquee-item">
        <img alt="Alpever" class="marquee-logo" loading="lazy" src="assets/images/companies-logo/Alpever.png">
        <span class="marquee-text">Alpever</span>
      </div>
      <div class="marquee-item">
        <img alt="Funstay" class="marquee-logo" loading="lazy" src="assets/images/companies-logo/Funstay.png">
        <span class="marquee-text">Funstay</span>
      </div>
      <div class="marquee-item">
        <img alt="OptInn Solutions" class="marquee-logo" loading="lazy" src="assets/images/companies-logo/OptInn-solutions.png">
        <span class="marquee-text">OptInn Solutions</span>
      </div>
      <div class="marquee-item">
        <img alt="TACT" class="marquee-logo" loading="lazy" src="assets/images/companies-logo/TACT.png">
        <span class="marquee-text">TACT</span>
      </div>
      <div class="marquee-item">
        <img alt="Yolohealth" class="marquee-logo" loading="lazy" src="assets/images/companies-logo/Yolohealth.png">
        <span class="marquee-text">Yolohealth</span>
      </div>
      <div class="marquee-item">
        <img alt="Thrillophilia" class="marquee-logo" loading="lazy" src="assets/images/companies-logo/thrillophilia.png">
        <span class="marquee-text">Thrillophilia</span>
      </div>
    </div>
  </div>
</section>